export default {
    isLogin : false,
    history : [],
    lnb : {
        loaded : false,
        category : [],
    },
    scroll: 0
}
